export const orderSortableColumnEnum = {
    orderStatus: 'OrderStatus',
    contrahentName: 'ContrahentName',
    date: 'Date',
    totalGrossPrice: 'TotalGrossPrice'
};